/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { HttpService } from '../service/http.service';
import { PersistenceService } from '../service/persistence.service';
import { CoreInitializer } from '../core.initializer';

@NgModule({
  declarations: [],
  providers: [
    HttpService,
    PersistenceService
  ],
  imports: [HttpClientModule],
  exports: []
})
export class CoreModule {

  constructor() {
    CoreInitializer.initialize();
  }

}
